//  {/* Hall management */}

//  <div className={`${style.tile} ${style.hall1}`} onClick={() => {
//     window.open("https://sourav9063.github.io/hall_management_rf/", '_blank')
// }}
//     style={{ transform: `translateX(${scrollPosition}px)` }}
// >
//     <div className={style.title}>Hall Management</div>
//     <img alt="Hall Management " src="https://user-images.githubusercontent.com/53114581/202853827-47a44716-f0b2-4c0c-b831-5b651e6c8688.jpg" />
// </div>
// <div className={`${style.tile} ${style.hall2}`} onClick={() => {
//     window.open("https://github.com/Sourav9063/hall_management_rf", '_blank')
// }} >
//     <img alt='Hall Management' src="https://user-images.githubusercontent.com/53114581/202853980-62389a23-3935-4666-9a00-8a5824fb4151.jpg" />
// </div>

// {/* uBookSharing */}
// <div className={`${style.tile} ${style.uBook1}`} onClick={() => {
//     window.open("https://github.com/Sourav9063/uBookSharing", '_blank')
// }}
//     style={{ transform: `translateY(${-1 * scrollPosition}px)` }}

// >
//     <div className={style.title} >uBookSharing</div>
//     {/* <img alt="uBook" src="https://user-images.githubusercontent.com/53114581/118112856-61972c00-b407-11eb-8004-1f516bbf91f4.png" /> */}

//     <video muted
//         onMouseOver={event => {
//             event.target.play();
//         }}
//         onMouseOut={event => event.target.pause()}

//         onPointerUp={event => event.target.pause()}
//         onPointerEnter={event => event.target.play()}
//         onPointerLeave={event => event.target.pause()}

//         poster="https://user-images.githubusercontent.com/53114581/118112856-61972c00-b407-11eb-8004-1f516bbf91f4.png"

//         src="https://user-images.githubusercontent.com/53114581/208036045-c13bdbf0-aacb-4b09-af9b-c8f61685230a.mp4" autoPlay loop ></video>

// </div>

// <div className={`${style.tile} ${style.uBook2}`} onClick={() => {
//     window.open("https://github.com/Sourav9063/uBookSharing", '_blank')
// }}
//     style={{ transform: `translateX(${-1.3 * scrollPosition}px) rotate(10deg)` }}

// >
//     <img alt='uBookSharing' src="https://user-images.githubusercontent.com/53114581/118114615-a91eb780-b409-11eb-8f46-851c73e3d8fd.png" />
// </div>
// <div className={`${style.tile} ${style.uBook3}`} onClick={() => {
//     window.open("https://github.com/Sourav9063/uBookSharing", '_blank')
// }}
//     style={{ transform: `translateY(${-1.4 * scrollPosition}px) rotate(-10deg)` }}

// >
//     <img alt='uBookSharing' src="https://user-images.githubusercontent.com/53114581/118113292-ebdf9000-b407-11eb-9a5d-d1db4f23ce4d.png" />
// </div>

// {/* Obstacle Detection */}
// <div className={`${style.tile} ${style.obstacle1}`} onClick={() => {
//     window.open("https://github.com/Sourav9063/obstacles_detection", '_blank')
// }}
//     style={{ transform: `translateX(${-1 * scrollPosition}px)` }}

// >
//     <div className={style.title}>Obstacle Detection</div>
//     <img alt='obstacle' src="https://user-images.githubusercontent.com/53114581/201062121-35f042c7-a4e4-4fe6-9100-8a0ba1ec8b8f.jpg" />
// </div>

// <div className={`${style.tile} ${style.obstacle2}`} onClick={() => {
//     window.open("https://github.com/Sourav9063/obstacles_detection", '_blank')
// }}
//     style={{ transform: `translateX(${-1.4 * scrollPosition}px) rotate(10deg)` }}

// >
//     <img alt="obstacle" src="https://user-images.githubusercontent.com/53114581/201062149-c11e154a-5f92-45c1-bf19-c868e4d543a9.jpg" />
// </div>

// {/* FTP Searcher */}
// <div className={`${style.tile} ${style.ftp}`} onClick={() => {
//     window.open("https://github.com/Sourav9063/ftp_searcher", '_blank')
// }}
//     style={{ transform: `translateX(${1 * scrollPosition}px) ` }}
// >
//     <div className={style.title}>FTP Searcher</div>
//     <img alt='obstacle' src="https://user-images.githubusercontent.com/53114581/190019523-8446eb43-4751-446c-8505-547fe58f3ff6.jpg" />

// </div>
// {/* Hungry Camper */}
// <div className={`${style.tile} ${style.hungry}`} onClick={() => {
//     window.open("https://github.com/Sourav9063/Hungry-Camper-scripts", '_blank')
// }}
//     style={{ transform: `translateX(${1 * scrollPosition}px) translateY(${-1 * scrollPosition}px) ` }}
// >
//     <div className={style.title}>Hungry Camper</div>
//     <img alt='hungry camper' src="https://user-images.githubusercontent.com/53114581/148637656-447cdf3b-5267-4e43-99aa-7fb7237184b9.png" />
// </div>
// <div className={`${style.tile} ${style.hungry1}`} onClick={() => {
//     window.open("https://github.com/Sourav9063/Hungry-Camper-scripts", '_blank')
// }}>
//     <img alt='hungry Camper' src="https://user-images.githubusercontent.com/53114581/148637660-776055e8-1fc3-4f40-84f8-3fdc2cde4e65.png" />
// </div>
// <div className={`${style.tile} ${style.hungry2}`} onClick={() => {
//     window.open("https://github.com/Sourav9063/Hungry-Camper-scripts", '_blank')
// }}>
//     <img alt='Hungry Camper' src="https://user-images.githubusercontent.com/53114581/148637665-3e0ccf21-cb50-4c7d-99b3-51d9947b8de3.png" />
// </div>

// {/* News Blog */}
// <div className={`${style.tile} ${style.blog}`} onClick={() => {
//     window.open("https://github.com/Sourav9063/Blog-CRUD-by-NodeJS", '_blank')
// }}
//     style={{ transform: `translateY(${1.2 * scrollPosition}px) rotate(-10deg)` }}
// >
//     <div className={style.title}>News Blog</div>
//     <img alt='News Blogs' src="https://user-images.githubusercontent.com/53114581/202858064-3a594637-0e01-4142-a17b-211b5866d448.jpg" />
// </div>
// <div className={`${style.tile} ${style.blog1}`} onClick={() => {
//     window.open("https://github.com/Sourav9063/Blog-CRUD-by-NodeJS", '_blank')
// }}
//     style={{ transform: `translateX(${1.2 * scrollPosition}px) translateY(${1 * scrollPosition}px)  rotate(10deg)` }}

// >
//     <img alt='News Blogs' src="https://user-images.githubusercontent.com/53114581/202858172-af9b10d7-1c8f-4e56-857b-86be59085c47.jpg" />
// </div>

// {/* Touch The Ball */}
// <div className={`${style.tile} ${style.touch}`} onClick={() => {
//     window.open("https://sourav9063.github.io/Touch-The-Ball/", '_blank')
// }}
//     style={{ transform: `translateX(${1.2 * scrollPosition}px) translateY(${1 * scrollPosition}px) ` }}

// >
//     <div className={style.title}>Touch The Ball</div>
//     <img alt='Touch the ball' src="https://user-images.githubusercontent.com/53114581/202858785-0711683e-262e-47ac-9822-f5383d9440de.jpg" />
// </div>

// extract all onClick functions into a object

const projectsData = {
  "Hall Management": {
    title: "Hall Management",
    images: [
      "https://user-images.githubusercontent.com/53114581/202853827-47a44716-f0b2-4c0c-b831-5b651e6c8688.jpg",
      "https://user-images.githubusercontent.com/53114581/202853980-62389a23-3935-4666-9a00-8a5824fb4151.jpg",
    ],
    links: [
      "https://github.com/Sourav9063/hall_management_rf",
      "https://sourav9063.github.io/hall_management_rf/",
    ],
    description: "",
    tech: ["NodeJS", "ExpressJS", "MySQL", "JWT token", "React"],

    // onClicks: [
    //     () => window.open("https://sourav9063.github.io/hall_management_rf/", '_blank'),
    // ]
  },
  uBookSharing: {
    title: "uBookSharing",
    images: [
      "https://user-images.githubusercontent.com/53114581/118112856-61972c00-b407-11eb-8004-1f516bbf91f4.png",
      "https://user-images.githubusercontent.com/53114581/118113063-a02ce680-b407-11eb-8a3d-b3a416460e8b.png",
      "https://user-images.githubusercontent.com/53114581/118113104-ad49d580-b407-11eb-8f5d-477d27e2d20d.png",
      "https://user-images.githubusercontent.com/53114581/118113768-84761000-b408-11eb-8643-2f93778c5a1c.png",
      "https://user-images.githubusercontent.com/53114581/118113843-9eafee00-b408-11eb-9bc1-a15be24807d6.png",
      "https://user-images.githubusercontent.com/53114581/118114654-b340b600-b409-11eb-8bbd-e383e3b029b6.png",
      "https://user-images.githubusercontent.com/53114581/118114615-a91eb780-b409-11eb-8f46-851c73e3d8fd.png",
      "https://user-images.githubusercontent.com/53114581/118113292-ebdf9000-b407-11eb-9a5d-d1db4f23ce4d.png",
    ],
    videos: [
      "https://user-images.githubusercontent.com/53114581/208036045-c13bdbf0-aacb-4b09-af9b-c8f61685230a.mp4",
    ],
    links: [
      "https://github.com/Sourav9063/uBookSharing",
      "https://github.com/Sourav9063/uBookSharing/tags",
    ],
    description:
      "University based Book sharing app. Users are divided according to their Universities. Anyone can upload details of his/her book for sell/rent/share and anyone can request them for that book providing their contact information. Individual's contact information is not publicly available. Only when someone requests to get a book then and only then the owner of the book will get the contact information. If you want to try it out here is an auth credential Email: sourav.ahmed5654@gmail.com Password: 12345678",
    tech: ["Flutter", "Firebase", "Rive"],

    // onClicks: [
    //     () => window.open("https://github.com/Sourav9063/uBookSharing", '_blank'),
    // ]
  },
  "Hungry Camper": {
    title: "Hungry Camper",
    images: [
      "https://user-images.githubusercontent.com/53114581/148637656-447cdf3b-5267-4e43-99aa-7fb7237184b9.png",
      "https://user-images.githubusercontent.com/53114581/148637660-776055e8-1fc3-4f40-84f8-3fdc2cde4e65.png",
      "https://user-images.githubusercontent.com/53114581/148637665-3e0ccf21-cb50-4c7d-99b3-51d9947b8de3.png",
    ],
    links: [
      "https://github.com/Sourav9063/Hungry-Camper-scripts",
      "https://drive.google.com/drive/folders/1PgYjzrHBPHihQ0aPrk3Ni7PxuUWpbZd3?usp=sharing",
    ],
    description: "",
    tech: ["Unity", "C#"],
    // onClicks: [
    //     window.open("https://github.com/Sourav9063/Hungry-Camper-scripts", '_blank'),
    //     window.open("https://drive.google.com/drive/folders/1PgYjzrHBPHihQ0aPrk3Ni7PxuUWpbZd3?usp=sharing", '_blank')

    // ]
  },
  "News Blog": {
    title: "News Blog",
    images: [
      "https://user-images.githubusercontent.com/53114581/202858064-3a594637-0e01-4142-a17b-211b5866d448.jpg",
      "https://user-images.githubusercontent.com/53114581/202858172-af9b10d7-1c8f-4e56-857b-86be59085c47.jpg",
    ],
    links: ["https://github.com/Sourav9063/Blog-CRUD-by-NodeJS"],
    description: "",
    tech: ["NodeJS", "ExpressJS", "MySQL", "JWT token", "React"],

    // onClicks: [
    //     window.open("https://github.com/Sourav9063/Blog-CRUD-by-NodeJS", '_blank')
    // ]
  },
  "Sync Play": {
    title: "Sync Play",
    images: [
      "https://user-images.githubusercontent.com/53114581/290510162-609cdec5-ed48-40bc-a13b-8618ffabaa50.png",
      "https://user-images.githubusercontent.com/53114581/290508959-6b5fdfd0-b8ad-4af5-b699-6dd2ef777f9d.png",
      "https://user-images.githubusercontent.com/53114581/268676290-e001ce11-948d-40e0-9c54-9f3bca1bf32f.png",
    ],
    videos: [
      "https://user-images.githubusercontent.com/53114581/266378331-4827debc-3649-44fa-a8bf-4c4c5af3abd1.mp4",
    ],
    links: [
      "https://github.com/Sourav9063/watchtogether",
      "https://syncplay.vercel.app/",
    ],
    description:
      "A hobby project made using NextJs and Socket.io where Multiple people can join your room via an invitation link and watch videos together with shared controls like Play, Pause, Seek, Source change, etc. Both local videos and cloud-stored videos are supported",
    tech: ["NodeJS", "ExpressJS", "MySQL", "JWT token", "React"],
  },
  "Touch The Ball": {
    title: "Touch The Ball",
    images: [
      "https://user-images.githubusercontent.com/53114581/202858785-0711683e-262e-47ac-9822-f5383d9440de.jpg",
    ],
    links: [
      "https://github.com/Sourav9063/Touch-The-Ball",
      "https://sourav9063.github.io/Touch-The-Ball/",
    ],
    description:
      " A Fun Games I made using JavaScript. It has a high score system and you can compete with your friends.",

    tech: ["HTML", "CSS", "JavaScript"],

    // onClicks: [
    //     window.open("https://sourav9063.github.io/Touch-The-Ball/", '_blank')

    // ]
  },
  "Game of Fortune": {
    title: "Game of Fortune",
    images: [
      "https://user-images.githubusercontent.com/53114581/244893835-8b8882ed-1329-4311-bccb-971aac14cff0.png",
    ],
    links: [
      "https://github.com/Sourav9063/JsGameSBH",
      "https://sourav9063.github.io/JsGameSBH/",
    ],
    description: "A fun game I made using JavaScript.",
    tech: ["HTML", "CSS", "JavaScript"],
  },
  "Obstacle Detection": {
    title: "Obstacle Detection",
    images: [
      "https://user-images.githubusercontent.com/53114581/201062121-35f042c7-a4e4-4fe6-9100-8a0ba1ec8b8f.jpg",
      "https://user-images.githubusercontent.com/53114581/201062149-c11e154a-5f92-45c1-bf19-c868e4d543a9.jpg",
    ],
    links: [
      "https://github.com/Sourav9063/obstacles_detection",
      "https://youtu.be/YIr5vqj7AQA",
    ],
    description:
      "Obstacles detection for blind person.\nUsing tensor flow we map the world in 3d. Then taking the center pixels value(near of far) we map it with device's Vibrator. This allows a blind person to find his/her way. When device detects objects near the camera, it vibrates for 200ms and warns the user about the position on obstacle. Other wise it vibrates for 50ms.",
    tech: ["Android Studio", "Java", "Tensorflow"],

    // onClicks: [
    //     window.open("https://github.com/Sourav9063/obstacles_detection", '_blank'),
    //     window.open("https://youtu.be/YIr5vqj7AQA", '_blank')

    // ]
  },
  "FTP Searcher": {
    title: "FTP Nextron",
    images: [
      "https://user-images.githubusercontent.com/53114581/242640601-ef725b70-c01a-4142-9616-73799580af51.png",
      "https://user-images.githubusercontent.com/53114581/190019523-8446eb43-4751-446c-8505-547fe58f3ff6.jpg",
      "https://user-images.githubusercontent.com/53114581/242640671-af94327a-ff8b-4fd0-887b-53cde1f6ca19.png",
      "https://user-images.githubusercontent.com/53114581/189787355-fe77adf2-8f67-4792-abed-af7fb61b99c2.jpg",
    ],
    links: [
      "https://github.com/Sourav9063/ftp-nextron",
      "https://sourav9063.github.io/ftp-nextron/",
      "https://github.com/Sourav9063/ftp_searcher",
    ],
    description:
      "All ftp links for media and live tv of Bangladesh. This program searches through all available links in Bangladesh and enlists all working links for your Internet service provider and allows you to open them in your browser.Made using ElectronJs. It's a UI project of Ftp Searcher",
    tech: ["NodeJS", "ElectronJS", "NextJS"],

    // onClicks: [
    //     window.open("https://github.com/Sourav9063/ftp_searcher", '_blank')

    // ]
  },
  "Dashboard Foundation": {
    title: "Dashboard Foundation",
    images: [],
    links: ["https://pathao.com"],
    description:
      "Engineered enterprise NextJs framework with OpenAPI-driven type generation and Zod validation, powering rapid cross-sector development with shadcn UI, centralized auth/RBAC, and embedded AI guardrails.",
    tech: ["NextJS", "OpenAPI", "Zod", "shadcn UI"],
  },
  "Pathao Map": {
    title: "Pathao Map",
    images: [],
    links: ["https://maps.pathao.io/"],
    description:
      "Architected microservices-based community platform (Alexander) with RBAC for gathering and validating POIs serving 100K+ daily users.",
    tech: ["GoLang", "VueJS", "NuxtJS", "Docker"],
  },
  Loop: {
    title: "Loop",
    images: [],
    links: ["https://pathao.com"],
    description:
      "Built campaign management platform handling marketing operations across all services with bulk XLSX uploads, robust file handling, and real-time analytics.",
    tech: ["NextJS", "Go", "PostgreSQL"],
  },
  Mission: {
    title: "Mission",
    images: [],
    links: ["https://pathao.com"],
    description:
      "Developed gamification platform with event-based listeners rewarding users for action streaks. Built dashboard for mission entry, phase goal management, and analytics.",
    tech: ["NextJS", "Go", "PostgreSQL", "Redis", "BigQuery"],
  },
  "Resto Web": {
    title: "Resto Web",
    images: [],
    links: ["https://restoweb.p-stageenv.xyz/"],
    description:
      "Engineered restaurant SaaS with WebSocket real-time notifications, dynamic menus, and analytics dashboard.",
    tech: ["NextJS", "Zod", "TypeScript", "WebSocket"],
  },
  "Year End Wrap": {
    title: "Year End Wrap",
    images: [],
    links: [
      "https://wrapped.pathao.com/eyJvcmQiOlsyNjMsMTAsMCwyMiwwLDFdLCJ1c2ciOlsxMTk0NjQsMjc5MzMuNjIsInAiXSwiY2lkIjoxLCJ1dCI6ImEiLCJtZSI6WyJyIiwiciIsMTkwMV0sInAiOiJiL3ZldGVyYW4ifQ==",
    ],
    description:
      "Engineered interactive 2025 wrap experience integrated without app updates. Optimized assets and solved critical cross-platform (iOS/Android) compatibility issues.",
    tech: ["NextJS", "TypeScript"],
  },
  GariKoi: {
    title: "GariKoi",
    images: [],
    links: ["https://pathao.com"],
    description:
      "Developed real-time geo tracking system visualizing driver locations, allocation/deallocation for operations.",
    tech: ["NextJS", "Go", "Google Maps API"],
  },
  Mapsense: {
    title: "Mapsense",
    images: [],
    links: ["https://pathao.com"],
    description:
      "Built Chrome Extension and web tool to flag route anomalies, comparing actual vs suggested routes to detect map mismatches against prominent providers for ops to fix Pathao map.",
    tech: ["NextJS", "TypeScript", "PostgreSQL"],
  },
  Mapage: {
    title: "Mapage",
    images: [],
    links: ["https://mapage.net/stylist/landing-page"],
    description:
      "Built real-time communication system for reservation/payment platform with optimistic updates and conflict resolution.",
    tech: ["Socket.IO", "NextJS", "MongoDB"],
  },
  UUORK: {
    title: "UUORK",
    images: [],
    links: ["https://shellbeehaken.com/portfolio/8"],
    description:
      "Engineered cross-platform workspace app (ElectronJs + NextJs) with JWT authentication, real-time collaboration, and responsive design.",
    tech: ["NextJS", "ElectronJS"],
  },
  Honnemir: {
    title: "Honnemir",
    images: [],
    links: ["https://shellbeehaken.com/portfolio/6"],
    description:
      "Developed multimedia voting platform with GraphQL API, AWS Amplify, and S3 upload pipeline.",
    tech: ["NextJS", "GraphQL", "AWS Amplify"],
  },
  KriyaKarak: {
    title: "KriyaKarak",
    images: [],
    links: ["https://kriyakarak.com/"],
    description:
      "Implemented payment disbursement system with automated payouts and reconciliation dashboard for creative marketplace.",
    tech: ["NextJS", "MongoDB"],
  },
  "Flash Nvim for VSCode": {
    title: "Flash Nvim for VSCode",
    images: [
      "https://github.com/user-attachments/assets/9a416efd-0927-4df8-b1f1-81d1582f328c",
      "https://github.com/user-attachments/assets/b63c4987-9d73-4995-914a-4b6ceddbdfd6",
      "https://github.com/user-attachments/assets/e2f932e3-73c6-4acd-9d8c-9937bb116821",
    ],
    videos: [
      "https://github.com/Sourav9063/flash-nvim-for-vscode/raw/refs/heads/main/assets/444379853-b4660aa8-dd2d-4c9f-9622-c01521747a76.mp4",
    ],
    links: [
      "https://github.com/Sourav9063/flash-nvim-for-vscode",
      "https://marketplace.visualstudio.com/items?itemName=souravahmed.flash-vscode-latest",
    ],
    description:
      "Fast, precise, label-based code navigation inspired by Neovim's flash.nvim plugin. Jump to visible targets in 2-3 keystrokes, select symbols and code scopes, and integrate with VSCodeVim without requiring Vim knowledge.",
    tech: ["TypeScript", "VSCode API", "Tree-sitter", "VSCodeVim"],
  },
  "IPA Transcription of Bengali Texts": {
    title: "IPA Transcription of Bengali Texts (arXiv 2024)",
    images: [],
    links: [
      "https://arxiv.org/abs/2403.20084",
      "https://github.com/Sourav9063/IPA",
    ],
    description:
      "Standardized Bengali IPA phonetic transcription with novel dataset and deep learning model advancing NLP for low-resource languages. Datasets: DUALIPA (156k+ validated sentences) and Regional IPA (7 dialects).",
    tech: ["Python", "TensorFlow", "NLP", "Pandas"],
  },
};

module.exports = projectsData;
